import { IPSelectableOption } from 'baseComponents/Utils/SelectableOption';
import { TFunction } from 'i18next';
import Entity from 'models/entity';

export const TagInvalidChars = [',', ':'];

export enum TagSystemTypes {
  None = 0,
  Project = 1,
  MonitoringFinding = 4,
  NonConformity = 8,
  Incident = 9,
}

export enum TagSystemProjectTypes {
  None = 0,
  ProjectOnboarding = 1,
  ProjectImplHLS = 2,
  ProjectImplControls = 3,
  ProjectMigration = 4,
  ProjectCertification = 5,
}

export default class Tag {
  tagId: number;

  tagName: string;

  tagValue: string;

  tagColor: string;

  tagInfo?: string;

  tagSystemType?: number;

  tagSystemSubType?: number;

  usedCount: number;

  entity?: Entity;

  constructor() {
    this.tagId = 0;
    this.tagName = '';
    this.tagValue = '';
    this.tagColor = '';
    this.usedCount = 0;
  }

  value(): string {
    return this.tagName + ' : ' + this.tagValue;
  }

  static getEmptyTag(): Tag {
    const emptyTag = new Tag();
    emptyTag.tagName = '?';
    emptyTag.tagValue = '?';

    return emptyTag;
  }

  static GetSystemTypeText(systemType: number | undefined, t: TFunction<string[]>): string {
    switch (systemType) {
      case TagSystemTypes.Project:
        return t('tag:SystemTypes.Project');
      case TagSystemTypes.MonitoringFinding:
        return t('tag:SystemTypes.MonitoringFinding');
      case TagSystemTypes.NonConformity:
        return t('tag:SystemTypes.NonConformity');
      case TagSystemTypes.Incident:
        return t('tag:SystemTypes.Incident');
      default:
        return '';
    }
  }

  static GetSystemTypeTextInfo(systemType: number | undefined, t: TFunction<string[]>): string {
    switch (systemType) {
      case TagSystemTypes.Project:
        return t('tag:SystemTypes.ProjectInfo');
      case TagSystemTypes.MonitoringFinding:
        return t('tag:SystemTypes.MonitoringFindingInfo');
      case TagSystemTypes.NonConformity:
        return t('tag:SystemTypes.NonConformityInfo');
      case TagSystemTypes.Incident:
        return t('tag:SystemTypes.IncidentInfo');
      default:
        return '';
    }
  }

  static getSystemTypeOptions = (t: TFunction<string[]>): IPSelectableOption[] => {
    const options: IPSelectableOption[] = [
      { key: TagSystemTypes.None, text: '' },
      { key: TagSystemTypes.Project, text: t('tag:SystemTypes.Project'), title: t('tag:SystemTypes.ProjectInfo') },
      {
        key: TagSystemTypes.MonitoringFinding,
        text: t('tag:SystemTypes.MonitoringFinding'),
        title: t('tag:SystemTypes.MonitoringFindingInfo'),
      },
      {
        key: TagSystemTypes.NonConformity,
        text: t('tag:SystemTypes.NonConformity'),
        title: t('tag:SystemTypes.NonConformityInfo'),
      },
      { key: TagSystemTypes.Incident, text: t('tag:SystemTypes.Incident'), title: t('tag:SystemTypes.IncidentInfo') },
    ];

    return options;
  };

  clone(): Tag {
    const newTag = new Tag();
    newTag.tagId = this.tagId;
    newTag.tagName = this.tagName;
    newTag.tagValue = this.tagValue;
    newTag.tagColor = this.tagColor;
    newTag.tagInfo = this.tagInfo;
    newTag.usedCount = this.usedCount;
    newTag.tagSystemType = this.tagSystemType;
    newTag.tagSystemSubType = this.tagSystemSubType;

    return newTag;
  }
}
